import { FC, MouseEventHandler } from 'react'
import { Link } from 'react-router-dom'

import { Loading } from '..'

import './style.scss'

type ButtonProps = {
  className?: string,
  component?: 'button' | 'a' | 'link',
  type?: 'submit' | 'reset' | 'button'
  mode?: 'circle' | 'square' | ''
  to?: string,
  target?: '_blank' | '',
  color?: string,
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '',
  fullWidth?: boolean,
  disabled?: boolean,
  tabIndex?: number,
  borderRadius?: string,
  loading?: boolean,
  style?: any,
  onClick?: MouseEventHandler<HTMLButtonElement>
}

const Button:FC<ButtonProps> = ({
  children,
  className = '',
  component = 'button',
  type = 'button',
  mode = '',
  to = '',
  target,
  color = 'default',
  size = '',
  fullWidth = false,
  disabled = false,
  tabIndex,
  borderRadius,
  loading = false,
  style,
  onClick,

  ...rest
})  => {
  const cls = `btn btn--${color} ${size ? 'btn--' + size : ''} ${mode ? 'btn--' + mode : ''} ${fullWidth ? 'w-full' : ''} ${className}`

  return (
    <>
      {component === 'button' &&
          <button type={type} disabled={disabled} tabIndex={tabIndex} className={cls} style={{ borderRadius: (borderRadius !== undefined ? borderRadius : ''), ...style }} onClick={onClick} {...rest}>{children}</button>
      }
      {component === 'link' && <Link to={to} className={cls} style={style} {...rest}>{children}</Link>}
      {component === 'a' && <a href={to} target={target} className={cls} style={style} {...rest}>{children}</a>}
      {loading && <Loading size="md" align="center" overlay />}
    </>
  )
}

export { Button }